<template>
	<div class="webSiteIndexData">
		<!-- 网站索引数据 -->
		<clientModule class="indexData" moduletitle="网站索引数据">
			<div slot="moduletitle">
				网站索引数据

				<!-- 网址切换 -->
				<sky-dropdown-select
					class="site-list"
					@change="changeSite"
					v-model="siteId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
			</div>
			<div class="indexData_body">
				<div class="tittle">
					<div class="link">
						Google索引网页：
						<el-link type="primary" :underline="false">{{ domain }}</el-link>
					</div>
					<igDaterange
						:showTip="false"
						:value="selectTime"
						initType="DAYS_7"
						:clearable="false"
						:disabledDate="true"
						@change="timeChange"
					></igDaterange>
				</div>
				<div class="charts">
					<ve-histogram
						:data="chartData"
						:settings="chartSettings"
						:after-config="afterConfig"
						:dataEmpty="dataEmpty"
						:lineLoading="lineLoading"
					>
					</ve-histogram>
				</div>
			</div>
		</clientModule>

		<!-- 当前索引连接 -->
		<clientModule
			class="link_body"
			:isShowDetail="true"
			moduletitle="当前索引连接"
			@viewDetails="scan"
		>
			<data-list
				:table-style="{ name: 'webclient' }"
				:data="data"
				:columns="column"
				:page="page"
				:loading="loading"
				:page-size="page.pageSize"
				@page-size-changed="pageSizeChanged"
				@page-changed="pageChanged"
			></data-list>
		</clientModule>
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate.js';
import clientModule from '@/components/client/clientModule/clientModule';
import indexDataSer from '@/backend/services/indexData/indexDataSer.js';
import igDaterange from '@/components/client/ig-daterange';
import { getDateRegion } from '@/common/util.js';
import api from '@/backend/apiConfig/apiConfig';
import { mapGetters } from 'vuex';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';

const list = listPageCreate({
	searchConfig: {
		api: api.indexData.indexQueryDate,
		method: 'POST',
	},
	getQuery(obj, that) {
		let { domain } = that;
		return Object.assign(obj, {
			domain,
		});
	},
});

export default {
	name: 'webSiteIndexData',
	props: [],
	components: {
		clientModule,
		igDaterange,
		skyDropdownSelect,
	},
	mixins: [list],
	data() {
		let date = getDateRegion('DAYS_7', 'YYYY-MM-DD', '&').split('&');
		let start = date[0];
		let end = date[1];
		return {
			siteId: '',
			domain: '--',
			websiteList: [],
			selectTime: [start, end],
			lineLoading: false,
			dataEmpty: false,
			chartSettings: {
				labelMap: {
					frequency: '索引数量',
				},
			},
			chartData: {
				columns: ['date', 'frequency'],
				rows: [],
			},
			column: [
				{
					label: '网址链接',
					bind: 'link',
					type: 'preview',
					iconName: 'copy',
					dataStyle: {
						'justify-content': 'flex-start',
					},
					preview: async val => {
						this.copy(val);
					},
				},
				{
					label: '上次抓取时间',
					bind: 'lastCrawlTime',
				},
			],
		};
	},
	computed: {
		...mapGetters(['customerId']),
	},
	watch: {
		customerId: {
			async handler(val) {
				if (val) this.getWebsite();
				else this.$message.warning('您需要先选择一个客户');
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		// 网站下拉数据
		async getWebsite() {
			try {
				let { customerId } = this;
				let result = await getWebsiteByCustomer({
					customerId,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.siteId = result.data[0].id;
				this.domain = result.data[0].name;
				this.init();
			} catch (error) {
				console.log(error);
			}
		},
		// 网址选择切换
		changeSite(id) {
			let obj = this.websiteList.find(item => {
				return item.id === id;
			});
			this.domain = obj.name;
			this.init();
		},
		// 初始化
		init() {
			this.query();
			this.getIndexDate();
		},
		// 获取图表数据
		async getIndexDate() {
			let { selectTime, domain } = this;
			let [startDate, endDate] = selectTime;
			let res = await indexDataSer.indexDate({
				startDate,
				endDate,
				domain,
			});
			if (res.data && res.data.length > 0) {
				this.chartData.rows = res.data;
				this.lineLoading = false;
				this.dataEmpty = false;
			} else {
				this.dataEmpty = true;
			}
		},
		// 时间选择器change
		timeChange(val) {
			this.selectTime = val;
			this.getIndexDate();
		},
		// 图表配置
		afterConfig(options) {
			options.legend = {
				...options.legend,
				show: false,
			};
			return options;
		},
		// 重新扫描
		scan() {
			this.query();
		},
		// 复制
		copy(val) {
			let url = val.link; //拿到想要复制的值
			let copyInput = document.createElement('input'); //创建input元素
			document.body.appendChild(copyInput); //向页面底部追加输入框
			copyInput.setAttribute('value', url); //添加属性，将url赋值给input元素的value属性
			copyInput.select(); //选择input元素
			document.execCommand('Copy');
			this.$message.success('链接已复制！'); //弹出提示信息，不同组件可能存在写法不同
			copyInput.remove();
		},
	},
};
</script>

<style lang="scss" scoped>
.webSiteIndexData {
	min-height: calc(100vh - 175px);
	margin: 0px 20px 10px 20px;

	.link_body,
	.indexData {
		background-color: #fff;
	}

	.indexData {
		.indexData_body {
			.tittle {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 10px 30px 20px;

				.link {
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #333333;
				}
			}
		}
	}

	.link_body {
		margin-top: 20px;
	}
  
	.site-list {
		margin-left: 20px;
	}
}
</style>
